import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Label,
    Modal, ModalHeader, ModalBody, Table
} from "reactstrap"
import { accessRole } from '../../../../../../helpers/access_role'
import { ConfirmAlert } from '../../../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../../../helpers/ui/FileInput'
import CustomSelect from '../../../../../../helpers/ui/CustomSelect'
import { AvForm, AvField, } from "availity-reactstrap-validation"

import { Link, Redirect } from "react-router-dom"

import apiResponse from '../../../../../../services/apiResponse'

import { cancelToken } from "../../../../../../services/adapters/kepegawaian/diklatService"
import YearSelect from '../../../../GlobalComponents/YearSelect'
// import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'

import CreateBloc from '../Create/Blocs/CreateBloc'
import UpdateBloc from './Blocs/UpdateBloc'
import IndexBloc from '../Index/Blocs/DiklatBloc'

// let peg_uuid = JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_uuid : "";
// let peg_nip = JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_nip : "";
// if(accessRole('approve')){
//     peg_uuid = JSON.parse(localStorage.getItem('employeeSelected')) != null ? JSON.parse(localStorage.getItem('employeeSelected')).employee_uuid : "";
//     peg_nip = JSON.parse(localStorage.getItem('employeeSelected')) != null ? JSON.parse(localStorage.getItem('employeeSelected')).employee_nip : "";
// }
const urlParams = new URLSearchParams(window.location.search);
const uuid = urlParams.get('uuid');
const typename = 'Teknis';

var reformatEmployee = function(regions) {
    return regions.map(function(region) {
      var newObj = {};
      newObj["label"] = region.employee_nip+" - "+region.employee_name;
      newObj["value"] = region.employee_uuid;
      newObj["model"] = region;
      return newObj;
    });
};

class UpdateView extends Component {

    source
    createBloc = new CreateBloc()
    updateBloc = new UpdateBloc()
    indexBloc = new IndexBloc()

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            detail: [],
            trainingOption: [],
            regionOption: [],
            provinceOption: [],
            cityOption: [],
            modal: false,
            trainingFilter: {
                            filter_value: "",
                            page_number: 1,
                            page_size: 50,
                            sort_order: {
                                column: 'training_type_sort',
                                order: 'asc' 
                            }
                        },
            hoursDetail: {},
            domicile: 0,
            peg_uuid:'',
            slcemployeeuuid:'',
            peg_nip:''
        }
    }

    toggleModal = () => {
        this.setState({ modal: !this.state.modal })
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        console.log('cek form', values)
        this.setState({
            dataForm: {
                employee_nip: this.state.peg_nip,
                training_uuid: uuid,
                training_employee_uuid: this.state.peg_uuid,
                training_type: 'Teknis',
                ...values
            },
            confirm: true
        })
    }

    loadTraining = async () => {
        let offset = (this.state.trainingFilter.page_number-1)*this.state.trainingFilter.page_size
        const query = {
            type: 'Teknis',
            search: this.state.trainingFilter.filter_value,
            limit: this.state.trainingFilter.page_size,
            offset: offset,
            order: this.state.trainingFilter.sort_order.column,
            sort: this.state.trainingFilter.sort_order.order,
            status: 1
        }
        await this.updateBloc.fetchTrainingList(query, this.source.token)
    }

    loadDetail = async () => {
        const query = {
            uuid: uuid
        }
        await this.updateBloc.fetchDetail(query, this.source.token)
        this.loadHours()
    }

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm, 'file') // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        await this.updateBloc.fetchUpdate(formData)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    getCity = (province_uuid) => {
        const query = { 
            is_local: 1,
            type : 3,
            parent_uuid : province_uuid
        }
        this.indexBloc.fetchRegionCity(query, this.source.token)
    }



    loadHours = async () => {
        const query = {
            employee_uuid: this.state.peg_uuid,
            uuid: this.props.uuid
        }
        await this.indexBloc.fetchHours(query, this.source.token)
    }

    loadProvince = async () => {
        const query = { 
            parent_uuid: '61b47307-167d-489f-bb6c-c1c9662acab3',
            type: 2
        }
        await this.indexBloc.fetchRegionProvince(query, this.source.token)
    }

    loadRegion = async () => {
        const query = { type: 1 }
        await this.indexBloc.fetchRegion(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        // this.loadHours()
        this.loadTraining()
        this.loadDetail()
        this.loadRegion()
        this.loadProvince()
    }

    componentDidMount() {
        this.setTokenAPI()

        this.indexBloc.regionCityChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ cityOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.hoursChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ 
                        hoursDetail: result.data.response
                    })
                    break;
                default: 
                    break;
            }
        })

        this.indexBloc.regionProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ provinceOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.regionChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ regionOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })

        this.updateBloc.trainingListChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        trainingOption: result.data.response.result
                    })
                    break;
            
                default:
                    break;
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response, domicile: result.data.response.detail?.training_domicile,
                        peg_uuid: result.data.response.detail?.training_employee_uuid,
                        slcemployeeuuid: result.data.response.detail?.training_employee_uuid,
                        peg_nip: result.data.response.result?.training_employee_nip
                     })
                    this.getCity(result.data.response.detail?.training_province_uuid)
                    break;
                default: 
                    break;
            }
        })

        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.createBloc.listPegawaiChanel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(result.data.response)
                        console.log('ini pegawai list'+this.props.type)
                        this.setState({
                            employeeItems: reformatEmployee(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.createBloc.fetchPegawai()

    }

    componentWillUnmount() {
        this.updateBloc.detailChannel?.unsubscribe()
        this.updateBloc.updateChannel?.unsubscribe()
        this.updateBloc.trainingListChannel?.unsubscribe()
        this.indexBloc.hoursChannel?.unsubscribe()
        this.indexBloc.regionChannel?.unsubscribe()
        this.indexBloc.regionCityChannel?.unsubscribe()
        this.indexBloc.regionProvinceChannel?.unsubscribe()
    }

    render() {
        const { type } = this.props
        const { result, detail } = this.state.detail
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            {/* <PegawaiSideBar active={`diklat&type=${type}`} /> */}

                            <Card className="">
                                <CardBody>
                                    <div className="float-end">
                                        <Link to={`index`}>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Edit Diklat {typename}</CardTitle>    
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        {result?.training_status == 2 ?
                                            <Row className="mb-3">
                                                <Col md="12">
                                                    <div class="alert-dismissible fade show alert alert-danger alert-dismissible fade show" role="alert">
                                                        <button type="button" class="close" aria-label="Close"><span aria-hidden="true">×</span></button>
                                                        <i class="uil uil-exclamation-octagon me-2"></i> Catatan Approval : {result?.training_note_approval}
                                                    </div>
                                                </Col>
                                            </Row>
                                            : '' }
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="diklatName"
                                                className="col-md-2 col-form-label"
                                            >
                                                Pegawai <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                            <CustomSelect
                                                    name="slcemployeeuuid"
                                                    onChange={selectedOption => this.setState({ slcemployeeuuid: selectedOption.value })}
                                                    validate={{ required: { value: true } }}
                                                    options={this.state.employeeItems}
                                                    classNamePrefix=""
                                                    placeholder="Pilih Pegawai..."
                                                    defaultValue={this.state.slcemployeeuuid}
                                                />
                                                <AvField
                                                    type="hidden"
                                                    value={this.state.slcemployeeuuid}
                                                    onChange={() => {}}
                                                    placeholder="Pilih Pegawai"
                                                    name="training_employee_uuid"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="diklatName"
                                                className="col-md-2 col-form-label"
                                            >
                                                Nama Diklat <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <CustomSelect 
                                                    name="training_training_type_uuid"
                                                    errorMessage="Pilih Diklat"
                                                    options={this.state.trainingOption} 
                                                    placeholder="Pilih Diklat"
                                                    validate={{ required: { value: true } }}
                                                    optionLabel={opt => opt.training_type_name + ', ' + opt.training_type_description}
                                                    optionValue="training_type_uuid"
                                                    defaultValue={result?.training_type_uuid}
                                                />
                                            </Col>
                                        </Row>
                                        <hr />
                                        <Label># Tempat Diklat</Label>
                                        <Row className="mb-3">
                                            <Label className="col-md-2 col-form-label">Dalam / Luar Negeri <span className="text-danger">*</span></Label>
                                             <Col md="3">
                                                <CustomSelect 
                                                    name="training_domicile"
                                                    errorMessage="Pilih Domisili"
                                                    options={[{ value: 0, label: 'Dalam Negeri' }, { value: 1, label: 'Luar Negeri' }]}
                                                    defaultValue={detail?.training_domicile ? detail.training_domicile : 0}
                                                    placeholder="Pilih Domisili"
                                                    onChange={opt => this.setState({ domicile: opt.value })}
                                                    validate={{ required: { value: true } }}
                                                    isSearchable={false}
                                                />
                                            </Col>                                           
                                        </Row>
                                        { this.state.domicile == 0 ?
                                            <Fragment>
                                                <AvField 
                                                    type="hidden" 
                                                    name="training_country_uuid" 
                                                    value={this.state.regionOption?.filter(value => value.region_name == 'Indonesia')[0]?.region_uuid} 
                                                />
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                    Provinsi <span className="text-danger">*</span>
                                                    </Label>
                                                    <Col md="3">
                                                        <CustomSelect 
                                                            name="training_province_uuid"
                                                            errorMessage="Pilih Provinsi"
                                                            onChange={value => this.getCity(value.region_uuid)}
                                                            options={this.state.provinceOption}
                                                            optionLabel="region_name"
                                                            optionValue="region_uuid" 
                                                            validate={{ required: { value: true } }}
                                                            defaultValue={detail?.training_province_uuid}
                                                            // defaultValue
                                                            placeholder="Pilih Provinsi"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Kota <span className="text-danger">*</span>
                                                    </Label>
                                                    <Col md="3">
                                                        <CustomSelect 
                                                            name="training_city_uuid"
                                                            errorMessage="Pilih Kota"
                                                            options={this.state.cityOption} 
                                                            optionLabel="region_name"
                                                            optionValue="region_uuid"
                                                            validate={{ required: { value: true } }}
                                                            defaultValue={detail?.training_city_uuid}
                                                            placeholder="Pilih Kota"
                                                        />
                                                    </Col>
                                                </Row>
                                            </Fragment>
                                            :
                                            <Fragment>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">Negara <span className="text-danger">*</span></Label>
                                                    <Col md="3">
                                                        <CustomSelect 
                                                            name="training_country_uuid"
                                                            errorMessage="Pilih Negara"
                                                            options={this.state.regionOption}
                                                            optionValue="region_uuid"
                                                            optionLabel="region_name"
                                                            placeholder="Pilih Negara"
                                                            defaultValue={detail?.training_country_uuid}
                                                            validate={{ required: { value: true } }}
                                                        />
                                                    </Col>                                           
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                    Kota <span className="text-danger">*</span>
                                                    </Label>
                                                    <Col md="3">
                                                        <AvField
                                                            name="training_city_text"
                                                            placeholder="Kota..."
                                                            type="text"
                                                            errorMessage="Masukkan Kota"
                                                            className="form-control"
                                                            defaultValue={detail?.training_city_text}
                                                            validate={{ required: { value: this.state.isLocal == 1 ? false : true } }}
                                                            id="place_of_birth_city_text"
                                                        />
                                                    </Col>
                                                </Row>
                                            </Fragment>
                                        }
                                        <hr/>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldPenyelenggara"
                                                className="col-md-2 col-form-label"
                                            >
                                                Penyelenggara <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="training_organizer"
                                                    placeholder="Penyelenggara..."
                                                    errorMessage="Masukkan Nama Penyelenggara"
                                                    type="text"
                                                    className="form-control"
                                                    id="fieldPenyelenggara"
                                                    value={result?.training_organizer}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldAngkatan"
                                                className="col-md-2 col-form-label"
                                            >
                                                Angkatan <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="training_generation"
                                                    placeholder="Angkatan..."
                                                    errorMessage="Masukkan Nama Angkatan"
                                                    type="number"
                                                    className="form-control"
                                                    id="fieldAngkatan"
                                                    value={result?.training_generation}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldTahun"
                                                className="col-md-2 col-form-label"
                                            >
                                                Tahun <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="2">
                                                <YearSelect 
                                                    name="training_year"
                                                    errorMessage="Masukkan Tahun"
                                                    placeholder="Tahun..."
                                                    defaultValue={result?.training_year}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldTglMulai"
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Mulai <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="3">
                                                <AvField
                                                    name="training_start_date"
                                                    placeholder="Tanggal Mulai..."
                                                    errorMessage="Masukkan Tanggal Mulai"
                                                    type="date"
                                                    className="form-control"
                                                    id="fieldTglMulai"
                                                    value={result?.training_start_date}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldTglSelesai"
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Selesai <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="3">
                                                <AvField
                                                    name="training_end_date"
                                                    placeholder="Tanggal Selesai..."
                                                    errorMessage="Masukkan Tanggal Selesai"
                                                    type="date"
                                                    className="form-control"
                                                    id="fieldTglSelesai"
                                                    value={result?.training_end_date}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldSTTP"
                                                className="col-md-2 col-form-label"
                                            >
                                                No STTP <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="5">
                                                <AvField
                                                    name="training_sttpp_number"
                                                    placeholder="No STTP..."
                                                    errorMessage="Masukkan No STTP"
                                                    type="text"
                                                    className="form-control"
                                                    id="fieldSTTP"
                                                    value={result?.training_sttpp_number}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldTglSTTP"
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal STTP <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="3">
                                                <AvField
                                                    name="training_sttpp_date"
                                                    placeholder="Tanggal STTP..."
                                                    errorMessage="Masukkan Tanggal STTP"
                                                    type="date"
                                                    className="form-control"
                                                    id="fieldTglSTTP"
                                                    value={result?.training_sttpp_date}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Label
                                                htmlFor="fieldJmlJam"
                                                className="col-md-2 col-form-label"
                                            >
                                                Jumlah Jam <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="3">
                                                <AvField
                                                    name="training_number_of_hours"
                                                    placeholder="Jumlah Jam..."
                                                    errorMessage="Masukkan Jumlah Jam"
                                                    type="number"
                                                    className="form-control"
                                                    id="fieldJmlJam"
                                                    value={result?.training_number_of_hours}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            {this.state.hoursDetail &&
                                                <>
                                                    <Label className="col-md-2 col-form-label"></Label>
                                                    <Label className="col-md-6 col-form-label">
                                                        <span className="text-danger" style={{ fontSize: '12px' }} >Note: Jumlah jam diklat anda tahun ini telah mencapai {this.state.hoursDetail?.total_hours} jam. <a href="javascript:void(0)" onClick={() => this.toggleModal() }>Lihat Detail</a></span>
                                                    </Label>
                                                </>
                                            }
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldJmlJam"
                                                className="col-md-2 col-form-label"
                                            >
                                                File Pendukung
                                            </Label>
                                            <Col md="6">
                                                <FileInput 
                                                    name="file"
                                                    defaultValue={detail?.document}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to={`/kepegawaian/home.html?diklat&type=${type}`}>
                                                    <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>    
                            </Card>    
                        </Col>
                    </Row> 
                </Container> 

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to={`/kepegawaian/diklat/teknis.html`} />
                : null }

                <Modal isOpen={this.state.modal} toggle={() => this.toggleModal()} size="lg">
                    <ModalHeader toggle={() => this.toggleModal()}>Keterangan Jam Diklat</ModalHeader>
                    <ModalBody>
                        <Table>
                            <thead>
                                <tr>
                                    <th>No</th>
                                    <th>Diklat</th>
                                    <th>Jam Diklat</th>
                                </tr>
                            </thead>
                            <tbody>
                                { this.state.hoursDetail.diklat?.map((value, index) => {
                                    return (
                                        <Fragment>
                                            <tr>
                                                <th>{index + 1}</th>
                                                <th>{value.training_type.training_type_name}, {value.training_type.training_type_description}</th>
                                                <th>{value.training_number_of_hours}</th>
                                            </tr>
                                        </Fragment>
                                    )
                                }) }
                            </tbody>
                        </Table>
                    </ModalBody>
                </Modal>

            </Fragment>
        )
    }
}

export default UpdateView
